<template>
  <div class="o-container o-container--xlarge">
    <section>
      <h3>Stammdaten bearbeiten</h3>
    </section>
    <section>
      <div class="o-grid o-grid--no-gutter">
        <div class="o-grid__cell">
          <h4>Stand-Leistungen</h4>
        </div>
        <div class="o-grid__cell top-buttons">
          <bos-button @click="newBoothService">Neue Stand-Leistung</bos-button>
        </div>
      </div>

      <bos-overview-table
        :data="boothServices"
        :columns="[
          {
            key: 'title',
            name: 'Name'
          }
        ]"
        deleteTitle="Stand-Leistung löschen"
        :deleteText="
          obj =>
            'Soll die Stand-Leistung <b>&quot;' +
            obj.title +
            '&quot;</b> wirklich gelöscht werden?'
        "
        :onEdit="editBoothService"
        :onDelete="deleteBoothService"
        :disableDelete="obj => obj.isUsed"
      />
    </section>
  </div>
</template>

<script>
import BosButton from '@/components/BosButton'
import ApiService from '@/services/ApiService'
import { forEach } from 'lodash'
import BosOverviewTable from '@/components/BosOverviewTable'

export default {
  name: 'AdminCoredataBoothServiceOverview',
  components: {
    BosButton,
    BosOverviewTable
  },
  methods: {
    newBoothService: function() {
      this.$router.push({
        name: 'AdminCoredataBoothServiceCreate'
      })
    },
    editBoothService: function(boothService) {
      this.$router.push({
        name: 'AdminCoredataBoothServiceEdit',
        params: {
          id: boothService._id
        }
      })
    },
    deleteBoothService: function(boothService) {
      ApiService.deleteBoothService(boothService._id).then(() => {
        this.boothServices = this.boothServices.filter(item => {
          return item._id !== boothService._id
        })
      })
    },
    getBoothServicesListing() {
      ApiService.getBoothServices().then(response => {
        this.boothServices = response.data
      })
    }
  },
  mounted() {
    this.getBoothServicesListing()
  },
  data() {
    return {
      boothServices: []
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/variables.scss';

.list-group-item {
  padding: 0.333rem 0;
  margin-bottom: 1rem;

  &:nth-child(even) {
    background-color: #f7f6f3;
  }
}

h3 {
  margin: 40px 0 0;

  &:first-child {
    margin-top: 0;
  }
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.bos-timeflow {
  text-align: center;
  list-style: none;
  display: inline-table;
  margin: 0 0 4rem 0;

  li {
    display: inline;

    span {
      display: block;
      float: left;
      height: 44px;
      background: rgba(104, 115, 116, 0.3);
      text-align: center;
      padding: 14px 10px 0 30px;
      position: relative;
      margin: 0 4px 0 0;

      font-size: $timeflow-font-size;
      text-decoration: none;
      color: #fff;

      &:after {
        content: '';
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 20px solid rgba(104, 115, 116, 0.3);
        position: absolute;
        right: -20px;
        top: 0;
        z-index: 1;
      }

      &:before {
        content: '';
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 20px solid #fff;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    &:first-child span {
      padding-left: 24px;

      &:before {
        display: none;
      }
    }

    &:last-child span {
      padding-right: 20px;

      &:after {
        display: none;
      }
    }

    &.active span {
      background: rgba(46, 150, 153, 0.7);

      &:after {
        border-left-color: rgba(46, 150, 153, 0.7);
      }
    }
  }
}

.top-buttons {
  float: right;
  text-align: right;
  padding-top: 20px;
  margin-bottom: 20px;

  button {
    margin-right: 1.333rem;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
